import { ChangeEvent, useContext } from 'react';

import { Icon, TextField } from '@atom/mui';
import { PlaylistAddCheckIcon } from '@atom/mui/icons';
import {
  convertMillisToDays,
  DAY_IN_MILLISECONDS,
} from '@atom/utilities/timeUtilities';

import FilterDateRange from './FilterDateRange';
import TaskCustomFieldsFilter from './TaskCustomFieldsFilter';
import WorkOrdersFiltersContext from './WorkOrdersFiltersContext';
import WorkTemplateTaskFieldsFilter from './WorkTemplateTaskFieldsFilter';

import classes from './filters.module.css';

const TaskFiltersSection = () => {
  const {
    filterForm,
    areFiltersDisabled,
    workOrderTemplate,
    updateFilterForm,
  } = useContext(WorkOrdersFiltersContext);

  const { taskDurationStart, taskDurationEnd } = filterForm;

  const handleDurationChange = (
    event: ChangeEvent<HTMLInputElement>,
    durationField: 'taskDurationStart' | 'taskDurationEnd',
  ) => {
    const inputValue = event.target.value;
    const updatedValue =
      inputValue === '' ? null : Number(inputValue) * DAY_IN_MILLISECONDS;

    updateFilterForm(durationField, updatedValue);
  };

  return (
    <div className={classes.filterSection}>
      <div className={classes.filterSectionHeader}>
        <Icon icon={PlaylistAddCheckIcon} />
        Task
      </div>
      <FilterDateRange
        label="Due Date"
        presetField="taskDueDateSelectValue"
        startField="taskDueDateStart"
        endField="taskDueDateEnd"
      />
      <FilterDateRange
        label="Start Date"
        presetField="taskStartDateSelectValue"
        startField="taskStartDateStart"
        endField="taskStartDateEnd"
      />
      <FilterDateRange
        label="Completed Date"
        presetField="taskCompletionDateSelectValue"
        startField="taskCompletionDateStart"
        endField="taskCompletionDateEnd"
      />
      <div className={classes.filterContainer}>
        <div className={classes.filterLabel}>Duration</div>
        <div className={classes.filterDurationRangeContainer}>
          <TextField
            type="number"
            disabled={areFiltersDisabled}
            value={
              taskDurationStart ? convertMillisToDays(taskDurationStart) : ''
            }
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              handleDurationChange(event, 'taskDurationStart')
            }
            data-cy="workOrdersFilterTaskDurationStartInput"
          />
          <div className={classes.filterLabel}>to</div>
          <TextField
            type="number"
            disabled={areFiltersDisabled}
            value={taskDurationEnd ? convertMillisToDays(taskDurationEnd) : ''}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              handleDurationChange(event, 'taskDurationEnd')
            }
            data-cy="workOrdersFilterTaskDurationEndInput"
          />
          <div className={classes.filterLabel}>Days</div>
        </div>
      </div>
      <TaskCustomFieldsFilter />
      {workOrderTemplate && <WorkTemplateTaskFieldsFilter />}
    </div>
  );
};

export default TaskFiltersSection;
